import Select from "react-select";
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 1, label:  "CPF" },
    { value: 2, label:  "CNPJ" },
];


const TipoInscricao = ({ field, placeholder, name, id, disabled=false, onKeyDown, className="" }) => {
    return (
        <Select 
            options={options}
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            id={id}
            isDisabled={disabled}
            onKeyDown={onKeyDown}
            className={className}
        />
    )
}

export { TipoInscricao, options as OpcoesTipoInscricao }